"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniq = void 0;
function uniq(list) {
    var table = {};
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var item = list_1[_i];
        if (typeof item === 'object') {
            table[JSON.stringify(item)] = item;
        }
        else {
            table[String(item)] = item;
        }
    }
    return Object.values(table);
}
exports.uniq = uniq;
//# sourceMappingURL=uniq.js.map